<template>
  <div class="" style="background: #efefef;">
    <Header></Header>
    <div class="flex mL15 mt15 mr15 mb15">
      <div style="padding: 20px; width: 100%;" class="mr10 rad10 bg-f">
        <div style='width: 100%; height: 20px'>
          <el-button icon='el-icon-setting' style='float: right' size='small' @click='settingButtonClick'>设置</el-button>
        </div>
        <div class="flex" style='width: 100%'>
          <div style="flex: 2" class="pt20">
            <div class="fl mr10 mb30" style='width: 200px'>
              <div class="fl imgBg"><img src="../../static/images/money.png" /></div>
              <span class="fb mL10">{{ wealthTitle }}</span>
              <el-tooltip effect="dark" :content="totalWealthTooltip" placement="top-start">
                <i class="el-icon-warning ml-5"></i>
              </el-tooltip>
              <br />
              <span class="f20 mL10 mt5 inline-block"
                    v-bind:style='this.totalWealth > this.userTotalWealth ? "color: rgba(146,208,80,1);" : "color: rgba(255,192,0,1)"'>{{ this.totalWealth }}</span>
              <br />
              <span class="f14 mL10 mt5 inline-block">目标：{{ this.userTotalWealth }}</span>
            </div>
            <div class="fl mr10 mb30" style='width: 200px'>
              <div class="fl imgBg"><img src="../../static/images/person.png" style="margin: 10px;" /></div>
              <span class="fb mL10">退休后月收入</span>
              <el-tooltip effect="dark" :content="aveIncomeTooltip" placement="top-start">
                <i class="el-icon-warning ml-5"></i>
              </el-tooltip>
              <br />
              <span class="f20 mL10 mt5 inline-block"
                    v-bind:style='this.aveIncome > this.userAveIncome ? "color: rgba(146,208,80,1);" : "color: rgba(255,192,0,1)"'>{{ this.aveIncome}}</span>
              <br />
              <span class="f14 mL10 mt5 inline-block">目标：{{ this.userAveIncome}}</span>
            </div>
            <div class="fl mr10 mb30" style='width: 200px'>
              <div class="fl imgBg"><img src="../../static/images/yield.png" style="width: 35px;margin: 13px;" /></div>
              <span class="fb mL10">替代率</span>
              <el-tooltip effect="dark" :content="replacementRateTooltip" placement="top-start">
                <i class="el-icon-warning ml-5"></i>
              </el-tooltip>
              <br />
              <span class="f20 mL10 mt5 inline-block"
                    v-bind:style='this.replacementRate > this.userReplacementRate ? "color: rgba(146,208,80,1);" : "color: rgba(255,192,0,1)"'>{{ this.replacementRate}}</span>
              <br />
              <span class="f14 mL10 mt5 inline-block">目标：{{ this.userReplacementRate}}</span>
            </div>
<!--            <div class="fl width-200">-->
<!--              <div class="fl imgBg"><img src="../../static/images/save.png" /></div>-->
<!--              <span class="fb mL10">目标达成率</span><br />-->
<!--              <span class="f28 mL10 mt5 inline-block">82%</span>-->
<!--            </div>-->
          </div>
<!--          <div id="imgChart" style="height: 0px;flex: 1; "></div>-->
        </div>
        <div class="leftMiddle">
          <p class="f16 fb">财富积累概览
            <el-tooltip effect="dark" :content="wealthAccumulationTooltip" placement="top-start">
              <i class="el-icon-warning ml-5"></i>
            </el-tooltip>
          </p>
          <div id="wealthAccumulation" style="height: 330px;"></div>
        </div>
        <div class="mt15">
          <p class="f16 fb">资产配置比例</p>
          <div id="investmentRatio" style="height: 270px;"></div>
        </div>
        <div class="mt15">
          <p class="f16 fb">养老金领取金额
            <el-switch class='fr mr20' v-model='assetSwitch'></el-switch>
            <span class="f12 fr mr5">考虑退休当年购买力</span>
          </p>
          <div id="assetAllocation" style="height: 270px;"></div>
        </div>
      </div>
      <el-drawer :visible.sync='drawer' direction='rtl' size='75%'
                 :show-close="false" :wrapper-closable="false" :with-header="false">
        <div style="width:340px; height: auto" class="rad10">
          <div class="wealth rad10 bg-f mb10">
            <p class="f16 mb10 fb">财富规划设置</p>
            <div class="block" v-for="(item, key) in wealthList" :key="key">
              <span class="demonstration fb">{{item.name}}</span>
              <el-slider v-model="item.value" @change="sliderChange(item, key)" :format-tooltip="handlDelta"></el-slider>
            </div>
          </div>
          <div class="pension rad10 bg-f mb10">
            <p class="f16 mb15 fb">社保养老金设置</p>
            <div class="mb10 selectDiv">
              <span class="fb inline-block width-90">城市</span>
              <el-select v-model="paramsData.city" placeholder="请选择" class="width-200" @change='inputChange'>
                <el-option v-for="item in cities" :key="item.name" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </div>
  <!--          <div class="mb10">-->
  <!--            <span class="fb inline-block width-90">性别</span>-->
  <!--            <el-button :class="genderButtonClass1" @click='genderSelected("male")'>男</el-button>-->
  <!--            <el-button :class="genderButtonClass2" style="margin-left: 0;" @click='genderSelected("female")'>女</el-button>-->
  <!--          </div>-->
  <!--          <div class="mb10 inputDiv">-->
  <!--            <span class="fb inline-block width-90">专项扣除</span>-->
  <!--            <el-input v-model="specialDeductions" class="rad20 inline-block width-200" placeholder="请输入专项扣除"></el-input>-->
  <!--          </div>-->
            <div class="mb10 numberYear">
              <span class="fb inline-block width-90">实际缴费年限</span>
              <el-input-number v-model="paramsData.currentSocialSecurityPaidYears" :min="0" :max="50" @change='inputChange'></el-input-number>
            </div>
            <div class="mb15 inputDiv">
              <span class="fb inline-block width-90">当前余额</span>
              <el-input v-model="paramsData.currentAccountBalanceP1" class="rad20 width-200" placeholder="请输入当前余额" @change='inputChange'></el-input>
            </div>
            <p class="f16 mb15 fb">补充养老储蓄福利</p>
            <div class="mb10 inputDiv">
              <span class="fb inline-block width-100">企/职业年金
                <el-tooltip effect="dark" :content="corporationP2Tooltip" placement="top-start">
                    <i class="el-icon-warning ml-5"></i>
                  </el-tooltip>
              </span>
  <!--            <el-input v-model="paramsData.currentAccountBalanceP2" class="rad20 width-200" placeholder="请输入当前余额" @change='inputChange'></el-input>-->
              <el-checkbox v-model='paramsData.isCorporationP2' @change='inputChange'></el-checkbox>
            </div>
            <div class="mb10 inputDiv">
              <span class="fb inline-block width-90">当前余额</span>
              <el-input v-model="paramsData.currentAccountBalanceP2" class="rad20 width-200" placeholder="请输入当前余额" @change='inputChange'></el-input>
            </div>
            <div class="mb30 inputDiv">
              <span class="fb inline-block width-90 fl mr5" style="margin-top: 3px;">缴费比例<br />(企业)</span>
              <el-input v-model="paramsData.formattedMonthlyEmployerContributionRatioP2" class="rad20 width-200" @change='p2InputChange(0)'></el-input>
  <!--            <el-slider v-model="annuityontribution" class="width-100 inline-block fl mt5"></el-slider>-->
  <!--            <el-select v-model="annuityontributionSelect" placeholder="偏债型" class="mL10 width-90">-->
  <!--              <el-option v-for="item in annuityontributionSelects" :key="item" :label="item" :value="item"></el-option>-->
  <!--            </el-select>-->
            </div>
            <div class="mb30 inputDiv">
              <span class="fb inline-block width-90 fl mr5" style="margin-top: 3px;">缴费比例<br />(个人)</span>
              <el-input v-model="paramsData.formattedMonthlyEmployeeContributionRatioP2" class="rad20 width-200" @change='p2InputChange(1)'></el-input>
            </div>
            <div class="mb15 inputDiv">
              <span class="fb inline-block width-90">领取年数</span>
              <el-input v-model="paramsData.selectedReceivingYearsP2" class="rad20 width-200" placeholder="请输入当前余额" @change='inputChange'></el-input>
            </div>
            <div class="mb10 selectDiv">
              <span class="fb inline-block width-90">投资组合类型</span>
              <el-select v-model="paramsData.portfolioExpectedReturnP2" placeholder="请选择" class="width-200" @change='inputChange'>
                <el-option v-for="item in portfolioExpectedOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <p class="f16 mb10 fb" style='text-align:left'>个人养老金设置</p>
            <div class="mb10 inputDiv" style="height: 70px;">
              <span class="fb inline-block width-90 fl mr5">商业养老
                <el-tooltip effect="dark" :content="actualMonthlyContributionP3Tooltip" placement="top-start">
                  <i class="el-icon-warning ml-5"></i>
                </el-tooltip>
                <br />(税优)<br />每月缴费</span>
              <el-input v-model="paramsData.actualMonthlyContributionP3" class="rad20 width-200" placeholder="请输入当前余额" @change='inputChange'></el-input>
  <!--            <el-slider v-model="annuityontribution" class="width-200 inline-block fl mt20"></el-slider>-->
  <!--            <el-slider v-model="annuityontribution" class="width-100 inline-block fl mt20"></el-slider>-->
  <!--            <el-select v-model="annuityontributionSelect" placeholder="偏债型" class="mL10 mt15 width-90">-->
  <!--              <el-option v-for="item in annuityontributionSelects" :key="item" :label="item" :value="item"></el-option>-->
  <!--            </el-select>-->
            </div>
            <div class="mb15 inputDiv">
              <span class="fb inline-block width-90">当前余额</span>
              <el-input v-model="paramsData.currentAccountBalanceP3" class="rad20 width-200" placeholder="请输入当前余额" @change='inputChange'></el-input>
            </div>
            <div class="mb15 inputDiv">
              <span class="fb inline-block width-90">领取年数</span>
              <el-input v-model="paramsData.selectedReceivingYearsP3" class="rad20 width-200" placeholder="请输入当前余额" @change='inputChange'></el-input>
            </div>
            <div class="mb10 selectDiv">
              <span class="fb inline-block width-90">投资类型</span>
              <el-select v-model="paramsData.portfolioPreferenceP3" placeholder="请选择" class="width-200" @change='inputChange'>
                <el-option v-for="item in portfolioPreferenceOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
  <!--          <div class="mb10 selectDiv" style="height: 70px;">-->
  <!--            <span class="fb inline-block width-90 fl mr5">商业养老<br />(非税优)<br />投资额度</span>-->
  <!--            <el-slider v-model="annuityontribution" class="width-100 inline-block fl mt20"></el-slider>-->
  <!--            <el-select v-model="annuityontributionSelect" placeholder="偏债型" class="mL10 mt15 width-90">-->
  <!--              <el-option v-for="item in annuityontributionSelects" :key="item" :label="item" :value="item"></el-option>-->
  <!--            </el-select>-->
  <!--          </div>-->
          </div>
        <el-button v-if='!dynamicCalculate' type='primary' style='width: 100%;' @click=getAllData(false)>计算</el-button>

<!--                <div class="btns">-->
<!--          <el-button class="base-bg co-f">养老策略规划</el-button>-->
<!--          <el-button class="base-bg co-f">产品策略匹配</el-button>-->
<!--        </div>-->
      </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default{
  data () {
    return {
      dynamicCalculate: false,
      annuityontribution: 20,
      annuityontributionSelect: '',
      annuityontributionSelects: [],
      balance: '',
      year: 1,
      specialDeductions: '',
      genderButtonClass1: 'base-bg co-f',
      genderButtonClass2: '',
      selectedGender: '',
      cities: [],
      wealthList: [
        // {name: '月储蓄比例', value: 30 ,key: 'monthlySavingRatio'},
        {name: '流动性资产比例', value: 35, key: 'demandDepositRatio'},
        {name: '固定收益型资产比例', value: 40, key: 'bondDominatedAssetRatio'},
        {name: '权益型资产比例', value: 25, key: 'equityDominatedAssetRatio'},
        // {name: '退休年龄', value: 65},
      ],
      sliderObj: {
        lockIdx: 2,
        lastLockKey: 0,
      },
      option: {},
      portfolioExpectedOptions: [
        {label: '平稳收益组合', value: 'STABLE_INCOME_PORTFOLIO'},
        {label: '稳健成长组合', value: 'CONSERVATIVE_GROWTH_PORTFOLIO'},
        {label: '积极进取组合', value: 'AGGRESSIVE_GROWTH_PORTFOLIO'}
      ],
      portfolioPreferenceOptions: [
        {label: '养老保险型产品', value: '保险'},
        {label: '养老基金型产品', value: '基金'},
        {label: '养老理财型产品', value: '理财'},
        {label: '养老储蓄型产品', value: '储蓄'},
      ],
      myChartData: [],
      getToken: '',
      routeData: {},
      paramsData: {
        // 财富规划设置
        // monthlySavingRatio: 30 / 100,
        demandDepositRatio: 35 / 100,
        bondDominatedAssetRatio: 40 / 100,
        equityDominatedAssetRatio: 25 / 100,
        // 社保养老金设置
        city: '北京',
        // gender: 'male',
        currentSocialSecurityPaidYears: 1,
        currentAccountBalanceP1: 0,
        // 年金设置
        isCorporationP2: false,
        currentAccountBalanceP2: 0,
        monthlyEmployeeContributionRatioP2: 0,
        formattedMonthlyEmployeeContributionRatioP2: '0%',
        monthlyEmployerContributionRatioP2: 0,
        formattedMonthlyEmployerContributionRatioP2: '0%',
        selectedReceivingYearsP2: 20,
        portfolioExpectedReturnP2: 'STABLE_INCOME_PORTFOLIO',
        // 个人年金设置
        actualMonthlyContributionP3: 0,
        currentAccountBalanceP3: 0,
        portfolioPreferenceP3: '理财',
        selectedReceivingYearsP3: 20,
      },
      data: {},
      wealthTitle: '退休时财富规模',
      totalWealth: 0,
      userTotalWealth: 0,
      aveIncome: 0,
      userAveIncome: 0,
      replacementRate: 0,
      userReplacementRate: 0,
      totalWealthTooltip: '考虑通货膨胀影响后：',
      aveIncomeTooltip: '考虑通货膨胀影响后：',
      replacementRateTooltip: '税后替代率：',
      wealthAccumulationTooltip: '财富规模不包括养老金',
      actualMonthlyContributionP3Tooltip: '每年上限12000，超过部分自动参与税优计算',
      corporationP2Tooltip: '企/职业年金享有税收优惠',
      assetSwitch: false,
      drawer: false,
      scale: 1
    }
   },
  components: { Header },
  computed: {
    token () {
      return this.$store.getters.getToken
    }
  },
  mounted () {
    this.scale = window.screen.width > 360 ? 1: window.screen.width/360
    this.dynamicCalculate = window._env_.dynamic_calculate || false
    this.getToken = this.token === '' ? localStorage.getItem('token') : this.token
    this.resetData()
    const params = this.$route.params
    if (Object.keys(this.$route.params).length !== 12) {
      this.$router.push({name: 'KnowYou'})
      return
    } else {
      this.routeData = {
        answer1: params.ANSWER1,
        answer2: params.ANSWER2,
        answer3: params.ANSWER3,
        answer4: params.ANSWER4,
        currentAge: params.age,
        existingSavingsAmount: params.alreadyScaleSaving,
        estimatedSpending: params.estimatedExpenses,
        incomeBeforeTax: params.preTaxIncome,
        otherIncome: params.otherIncome,
        gender: params.gender,
        answerMoney: params.answerMoney,
        answerYear: params.answerYear
      }
    }
    this.wealthTitle = '未来' + this.routeData.answerYear + '年财富规模'
    this.paramsData.currentSocialSecurityPaidYears = this.routeData.currentAge - 25 >= 0 ? this.routeData.currentAge - 25 : 0
    this.paramsData.currentAccountBalanceP1 =
      this.routeData.incomeBeforeTax * this.paramsData.currentSocialSecurityPaidYears *
      12 * 0.02
    let score = this.getScore()
    if (score < 12) {
      this.paramsData.portfolioPreferenceP3 = '保险'
    } else if (score >= 12 && score <= 17){
      this.paramsData.portfolioPreferenceP3 = '理财'
    } else if (score > 17){
      this.paramsData.portfolioPreferenceP3= '基金'
    }
    this.$http.get(this.$api.SupportCities, {}, {Authorization: `Bearer ${this.getToken}`}, window._env_.api_url, res => {
      this.cities = res.data
    })
    this.getAllData(true)

    // this.myChartData = [
    //   {
    //     value: [3, 4, 3, 4, 4],
    //     name: '收益属性'
    //   },
    //   {
    //     value: [5000, 14000, 28000, 26000, 42000],
    //     name: '现金流属性'
    //   },
    //   {
    //     value: [6000, 10000, 20000, 23000, 40000],
    //     name: '安全属性'
    //   }
    // ]
    // let myChart = this.$echarts.init(document.getElementById('imgChart'),'light')
    // myChart.setOption(
    //   {
    //   title: {
    //     text: 'Basic Radar Chart'
    //   },
    //   legend: {
    //     show: false
    //   },
    //   radar: {
    //     indicator: [
    //       { name: '收益性', max: 5 },
    //       { name: '安全性', max: 5 },
    //       { name: '流动性', max: 5 },
    //       { name: '养老充足率', max: 5 },
    //       { name: '目标达成率', max: 5 }
    //     ],
    //     name:{
    //       show: true, // 是否显示工艺等文字
    //       formatter: null, // 工艺等文字的显示形式
    //       textStyle: {
    //         color:'#000', // 工艺等文字颜色
    //         fontSize: 13
    //       }
    //     }
    //   },
    //   series: [
    //     {
    //       name: '收益性',
    //       type: 'radar',
    //       // label: {
    //       //   show: true,
    //       //   formatter: function (params) {
    //       //     return params.value;
    //       //   }
    //       // },
    //       data: this.myChartData
    //     }
    //   ]
    // }
//     {
//   color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
//   title: {
//     text: 'Customized Radar Chart'
//   },
//   legend: {},
//   radar: [
//     {
//       indicator: [
//         { text: 'Indicator1' },
//         { text: 'Indicator2' },
//         { text: 'Indicator3' },
//         { text: 'Indicator4' },
//         { text: 'Indicator5' }
//       ],
//       center: ['25%', '50%'],
//       radius: 120,
//       startAngle: 90,
//       splitNumber: 4,
//       shape: 'circle',
//       axisName: {
//         formatter: '【{value}】',
//         color: '#428BD4'
//       },
//       splitArea: {
//         areaStyle: {
//           color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
//           shadowColor: 'rgba(0, 0, 0, 0.2)',
//           shadowBlur: 10
//         }
//       },
//       axisLine: {
//         lineStyle: {
//           color: 'rgba(211, 253, 250, 0.8)'
//         }
//       },
//       splitLine: {
//         lineStyle: {
//           color: 'rgba(211, 253, 250, 0.8)'
//         }
//       }
//     },
//     {
//       indicator: [
//         { text: 'Indicator1', max: 150 },
//         { text: 'Indicator2', max: 150 },
//         { text: 'Indicator3', max: 150 },
//         { text: 'Indicator4', max: 120 },
//         { text: 'Indicator5', max: 108 },
//         // { text: 'Indicator6', max: 72 }
//       ],
//       center: ['75%', '50%'],
//       radius: 120,
//       axisName: {
//         color: '#fff',
//         backgroundColor: '#666',
//         borderRadius: 3,
//         padding: [3, 5]
//       }
//     }
//   ],
//   series: [
//     {
//       type: 'radar',
//       emphasis: {
//         lineStyle: {
//           width: 4
//         }
//       },
//       data: [
//         {
//           value: [100, 8, 0.4, -80, 2000],
//           name: 'Data A'
//         },
//         {
//           value: [60, 5, 0.3, -100, 1500],
//           name: 'Data B',
//           areaStyle: {
//             color: 'rgba(255, 228, 52, 0.6)'
//           }
//         }
//       ]
//     },
//     {
//       type: 'radar',
//       radarIndex: 1,
//       data: [
//         {
//           value: [120, 118, 130, 100, 99, 70],
//           name: 'Data C',
//           symbol: 'rect',
//           symbolSize: 12,
//           lineStyle: {
//             type: 'dashed'
//           },
//           label: {
//             show: true,
//             formatter: function (params) {
//               return params.value;
//             }
//           }
//         },
//         {
//           value: [100, 93, 50, 90, 70, 60],
//           name: 'Data D',
//           areaStyle: {
//             color: this.$echarts.graphic.RadialGradient(0.1, 0.6, 1, [
//               {
//                 color: 'rgba(255, 145, 124, 0.1)',
//                 offset: 0
//               },
//               {
//                 color: 'rgba(255, 145, 124, 0.9)',
//                 offset: 1
//               }
//             ])
//           }
//         }
//       ]
//     }
//   ]
// }
//     )

  },
  watch: {
    assetSwitch(val, oldVal) {
      this.drawAssetAllocationChart()
    }
  },
  methods: {
    getAllData (val) {
      const url = this.$api.AllData
      const params = {
        "DEFAULT": val,
        "CURRENT_AGE": this.routeData.currentAge,
        "CITY": this.paramsData.city,
        "GENDER": this.routeData.gender,
        "EXISTING_SAVINGS_AMOUNT": this.routeData.existingSavingsAmount,
        "INCOME_SUBJECT_TO_TAXATION": this.routeData.incomeBeforeTax,
        "OTHER_INCOMES": this.routeData.otherIncome,
        "ESTIMATED_SPENDING": this.routeData.estimatedSpending,
        "ACTUAL_MONTHLY_CONTRIBUTION_P3": this.paramsData.actualMonthlyContributionP3,
        "MONTHLY_EMPLOYEE_CONTRIBUTION_RATIO_P2": this.paramsData.monthlyEmployeeContributionRatioP2 / 100,
        "CURRENT_ACCOUNT_BALANCE_P3": this.paramsData.currentAccountBalanceP3,
        "MONTHLY_EMPLOYER_CONTRIBUTION_RATIO_P2": this.paramsData.monthlyEmployerContributionRatioP2 / 100,
        "PORTFOLIO_EXPECTED_RETURN_P2": this.paramsData.portfolioExpectedReturnP2,
        "CURRENT_SOCIAL_SECURITY_PAID_YEARS": this.paramsData.currentSocialSecurityPaidYears,
        "CURRENT_ACCOUNT_BALANCE_P1": this.paramsData.currentAccountBalanceP1,
        "CURRENT_ACCOUNT_BALANCE_P2": this.paramsData.currentAccountBalanceP2,
        "SELECTED_RECEIVING_YEARS_P2": this.paramsData.selectedReceivingYearsP2,
        "SELECTED_RECEIVING_YEARS_P3": this.paramsData.selectedReceivingYearsP3,
        "ANSWER1": this.routeData.answer1,
        "ANSWER2": this.routeData.answer2,
        "ANSWER3": this.routeData.answer3,
        "ANSWER4": this.routeData.answer4,
        "ANSWER5_1": this.routeData.answerYear,
        "ANSWER5_2": this.routeData.answerMoney,
        "IS_CORPORATION_P2": this.paramsData.isCorporationP2,
        "MONTHLY_SAVING_RATIO": 0,
        "PORTFOLIO_PREFERENCE_P3": this.paramsData.portfolioPreferenceP3,
        "DEMAND_DEPOSIT_RATIO": this.paramsData.demandDepositRatio,
        "BOND_DOMINATED_ASSET_RATIO": this.paramsData.bondDominatedAssetRatio,
        "EQUITY_DOMINATED_ASSET_RATIO": this.paramsData.equityDominatedAssetRatio
      }
      this.$http.post(url, params, {Authorization: `Bearer ${this.getToken}`}, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          this.data = res.data
          this.totalWealth = this.$customToMoney(this.data['est_total_wealth_after_n_years'].toFixed(0))
          this.userTotalWealth = this.$customToMoney(this.data['target_wealth_after_n_years'].toFixed(0))
          this.aveIncome = this.$customToMoney(this.data['est_ave_income_before_tax'].toFixed(0))
          this.userAveIncome = this.$customToMoney(this.data['target_ave_income_before_tax'].toFixed(0))
          this.replacementRate = (this.data['replacement_rate_before_tax'] * 100).toFixed(0) + '%'
          this.userReplacementRate = (this.data['target_replacement_rate'] * 100).toFixed(0) + '%'
          this.totalWealthTooltip = '考虑通货膨胀影响后：' + this.$customToMoney(this.data['valued_total_wealth_after_n_years'].toFixed(0))
          this.aveIncomeTooltip = '考虑通货膨胀影响后：' + this.$customToMoney(this.data['valued_ave_income_before_tax'].toFixed(0))
          this.replacementRateTooltip = '税后替代率：' + (this.data['replacement_rate_after_tax'] * 100).toFixed(0) + '%'
          this.refreshPage()
          this.drawer=false
        }
      })
    },
    getScore () {
      let score = 0
      switch (this.routeData.answer1) {
        case "保守":
          score += 2
          break
        case "中性":
          score +=4
          break
        case "激进":
          score +=6
          break
        default:
          break
      }
      switch (this.routeData.answer2) {
        case "1-3年":
          score += 2
          break
        case "5-10年":
          score += 4
          break
        case "10年以上":
          score += 6
          break
        default:
          break
      }
      switch (this.routeData.answer3) {
        case "第一个投资产品":
          score += 3
          break
        case "第二个投资产品":
          score += 6
          break
        default:
          break
      }
      switch (this.routeData.answer4) {
        case "基础":
          score += 2
          break
        case "舒适":
          score += 3
          break
        case "富足":
          score += 4
          break
        case "奢侈":
          score += 6
          break
        default:
          break
      }
      return score
    },
    refreshPage() {
      let wealthChart = this.$echarts.init(document.getElementById('wealthAccumulation'),'light')
      let self = this
      wealthChart.setOption({
        grid: {
          bottom: 40,
          top: 30,
          right: 30
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: function (params) {
            var res = `${params[0]['axisValue']}<br/>`
            for (var item in params) {
              var value = self.$customToMoney(params[item].value.toFixed(0))
              res += `${params[item].marker}${params[item].seriesName}: ${value}<br/>`
            }
            return res
          }
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: { show: true }
        //   }
        // },
        legend: {
          textStyle: {
            fontSize: 12,
          },
          data: [
            '社保个人账户',
            '企业补充养老储蓄账户',
            '个人养老金账户',
            // '总养老金账户金额',
            '财富规模'
          ]
        },
        xAxis: [
          {
            name:'岁',
            type: 'category',
            data: this.data['accum_overview_data']['age_list'],
            axisLabel: {
              fontSize: 8,
            },
            // axisLabel: {
            //   interval: 0,
            //   rotate: 40
            // }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              fontSize: 8,
              formatter: function (value) {
                return self.kmbt_transform(value, 1)
              }
            }
          },
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '社保个人账户',
            type: 'bar',
            stack: 'one',
            data: this.data['accum_overview_data']['account_amount_p1_data']
          },
          {
            name: '企业补充养老储蓄账户',
            type: 'bar',
            stack: 'one',
            data: this.data['accum_overview_data']['account_amount_p2_data']
          },
          {
            name: '个人养老金账户',
            type: 'bar',
            stack: 'one',
            data: this.data['accum_overview_data']['account_amount_p3_data']
          },
          {
            name: '财富规模',
            type: 'line',
            data: this.data['accum_overview_data']['total_wealth_data']
          }
        ]
      })
      this.drawAssetAllocationChart()
      var emphasisStyle = {
        itemStyle: {
          shadowBlur: 10,
          shadowColor: 'rgba(0,0,0,0.3)'
        }
      }
      let investmentRatioChart = this.$echarts.init(document.getElementById('investmentRatio'), 'light')
      investmentRatioChart.setOption({
          legend: {
            textStyle: {
              fontSize: 12,
            },
            data: ['流动性资产比例', '固定收益型资产比例', '权益型资产比例'],
          },
          // toolbox: {
          //   feature: {
          //     saveAsImage: { show: true }
          //   }
          // },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            },
            formatter: function (params) {
              var res = `${params[0]['axisValue']}<br/>`
              for (var item in params) {
                var value = self.$customToMoney((params[item].value*100).toFixed(0)) + '%'
                res += `${params[item].marker}${params[item].seriesName}: ${value}<br/>`
              }
              return res
            }
          },
          xAxis: {
            data: this.data['investment_ratio_data']['age_list'],
            name: '岁',
            axisLabel: {
              fontSize: 8,
            }
          },
          yAxis: {
            max: 1,
            min: 0,
            axisLabel: {
              fontSize: 8,
              formatter: function (value) {
                return parseFloat(value) * 100 + '%'
              }
            }
          },
          grid: {
            bottom: 30,
            right: 30
          },
          series: [
            {
              name: '流动性资产比例',
              type: 'line',
              stack: 'total',
              emphasis: emphasisStyle,
              areaStyle: {},
              data: this.data['investment_ratio_data']['demand_deposit_ratio']
            },
            {
              name: '固定收益型资产比例',
              type: 'line',
              stack: 'total',
              emphasis: emphasisStyle,
              areaStyle: {},
              data: this.data['investment_ratio_data']['bond_dominated_deposit_ratio']
            },
            {
              name: '权益型资产比例',
              type: 'line',
              stack: 'total',
              emphasis: emphasisStyle,
              areaStyle: {},
              data: this.data['investment_ratio_data']['equity_dominated_deposit_ratio']
            }
          ]
        })
    },
    drawAssetAllocationChart() {
      let self = this
      let el = document.getElementById('assetAllocation')
      let assetAllocationChart = this.$echarts.getInstanceByDom(el)
      if (assetAllocationChart !== null && assetAllocationChart !== '' && assetAllocationChart !== undefined) {
        assetAllocationChart.dispose()
      }
      assetAllocationChart = this.$echarts.init(el, 'light')
      let xAxisData, data1, data2, data3, data4
      if (this.assetSwitch) {
        xAxisData = this.data['valued_amount_withdrawal_data']['age_list']
        data1 = this.data['valued_amount_withdrawal_data']['income_at_retirement_year']
        data2 = this.data['valued_amount_withdrawal_data']['valued_income_after_retirement_p1_data']
        data3 = this.data['valued_amount_withdrawal_data']['valued_income_after_retirement_p2_data']
        data4 = this.data['valued_amount_withdrawal_data']['valued_income_after_retirement_p3_data']
      } else {
        xAxisData = this.data['amount_withdrawal_data']['age_list']
        data1 = this.data['amount_withdrawal_data']['income_at_retirement_year']
        data2 = this.data['amount_withdrawal_data']['income_after_retirement_p1_data']
        data3 = this.data['amount_withdrawal_data']['income_after_retirement_p2_data']
        data4 = this.data['amount_withdrawal_data']['income_after_retirement_p3_data']
        }
      var emphasisStyle = {
        itemStyle: {
          shadowBlur: 10,
          shadowColor: 'rgba(0,0,0,0.3)'
        }
      };
      assetAllocationChart.setOption({
        legend: {
          textStyle: {
            fontSize: 12,
          },
          data: ['社保月收入', '企业补充养老储蓄月收入', '个人养老金月收入', '退休前月收入'],
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: { show: true }
        //   }
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: function (params) {
            var res = `${params[0]['axisValue']}<br/>`
            for (var item in params) {
              var value = self.$customToMoney(params[item].value.toFixed(0))
              res += `${params[item].marker}${params[item].seriesName}: ${value}<br/>`
            }
            return res
          }
        },
        xAxis: {
          data: xAxisData,
          name: '岁'
        },
        yAxis: {
          axisLabel: {
            fontSize: 8,
            formatter: function (value) {
              return self.kmbt_transform(value, 1)
            }
          }
        },
        grid: {
          bottom: 30,
          right: 30
        },
        series: [
          {
            name: '社保月收入',
            type: 'bar',
            stack: 'two',
            emphasis: emphasisStyle,
            data: data2
          },
          {
            name: '企业补充养老储蓄月收入',
            type: 'bar',
            stack: 'two',
            emphasis: emphasisStyle,
            data: data3
          },
          {
            name: '个人养老金月收入',
            type: 'bar',
            stack: 'two',
            emphasis: emphasisStyle,
            data: data4
          },
          {
            name: '退休前月收入',
            type: 'bar',
            stack: 'one',
            emphasis: emphasisStyle,
            data: data1
          }
        ]
      })
    },
    handlDelta (e) {
      return `${e}%`
    },
    // genderSelected(val) {
    //   if (val !== this.selectedGender){
    //     if (val === 'male'){
    //       this.genderButtonClass1 = 'base-bg co-f'
    //       this.genderButtonClass2 = ''
    //       this.selectedGender = 'male'
    //     } else {
    //       this.genderButtonClass1 = ''
    //       this.genderButtonClass2 = 'base-bg co-f'
    //       this.selectedGender = 'female'
    //     }
    //     this.getAllData()
    //   }
    // },
    resetData(){
      this.city = '北京'
      this.wealthList = [
        // {name: '月储蓄比例', value: 30 ,key: 'monthlySavingRatio'},
        {name: '流动性资产比例', value: 35, key: 'demandDepositRatio'},
        {name: '固定收益型资产比例', value: 40, key: 'bondDominatedAssetRatio'},
        {name: '权益型资产比例', value: 25, key: 'equityDominatedAssetRatio'},
        // {name: '退休年龄', value: 65},
      ]
      this.sliderObj = {
        lockIdx: 2,
        lastLockIdx: 0,
      }
      this.selectedGender = 'male'
      this.paramsData = {
        // 财富规划设置
        // monthlySavingRatio: 30 / 100,
        demandDepositRatio: 35 / 100,
        bondDominatedAssetRatio: 40 / 100,
        equityDominatedAssetRatio: 25 / 100,
        // 社保养老金设置
        city: '北京',
        gender: 'male',
        currentSocialSecurityPaidYears: 1,
        currentAccountBalanceP1: 0,
        // 年金设置
        isCorporationP2: false,
        currentAccountBalanceP2: 0,
        monthlyEmployeeContributionRatioP2: 0,
        formattedMonthlyEmployeeContributionRatioP2: '0%',
        monthlyEmployerContributionRatioP2: 0,
        formattedMonthlyEmployerContributionRatioP2: '0%',
        selectedReceivingYearsP2: 20,
        portfolioExpectedReturnP2: 'STABLE_INCOME_PORTFOLIO',
        // 个人年金设置
        actualMonthlyContributionP3: 0,
        currentAccountBalanceP3: 0,
        portfolioPreferenceP3: '理财',
        selectedReceivingYearsP3: 20,
      }
    },
    logout () {
      console.log('logout')
      this.$router.push({name: 'Login'})
    },
    inputChange () {
      if (this.dynamicCalculate){
        this.getAllData(false)
      }
    },
    p2InputChange (val) {
      var input = 0
      if (val === 0) {
        // 修改企业缴费比例
        input = this.paramsData.formattedMonthlyEmployerContributionRatioP2
        input = this.formatInput(input)
        this.paramsData.formattedMonthlyEmployerContributionRatioP2 = input
        this.paramsData.monthlyEmployerContributionRatioP2 = parseFloat(input.split('%')[0])
      } else if (val === 1) {
        // 修改个人缴费比例
        input = this.paramsData.formattedMonthlyEmployeeContributionRatioP2
        input = this.formatInput(input)
        this.paramsData.formattedMonthlyEmployeeContributionRatioP2 = input
        this.paramsData.monthlyEmployeeContributionRatioP2 = parseFloat(input.split('%')[0])
      }
      if (this.dynamicCalculate) {
        this.getAllData(false)
      }
    },
    formatInput(input) {
      let res = ''
      if (typeof input === 'string' && input.indexOf('%') !== -1) {
        if (input.indexOf('%') !== input.length - 1) {
          res = input.replace('%', '')
        } else {
          res = input
        }
      } else {
        res = input + '%'
      }
      return res
    },
    kmbt_transform (value, fractionDigits) {
      // var index = parseFloat(value)
      var num = 1000
      if (Math.abs(value) < num) {
        return parseFloat(value.toFixed(fractionDigits))
      } else if (Math.abs(value) < Math.pow(num, 2)) {
        return parseFloat((value / num).toFixed(fractionDigits)) + 'k'
      } else if (Math.abs(value) < Math.pow(num, 3)) {
        return parseFloat((value / num / num).toFixed(fractionDigits)) + 'm'
      } else if (Math.abs(value) < Math.pow(num, 4)) {
        return parseFloat((value / num / num / num).toFixed(fractionDigits)) + 'b'
      } else if (Math.abs(value) < Math.pow(num, 5)) {
        return parseFloat((value / num / num / num / num).toFixed(fractionDigits)) + 't'
      }
    },
    settingButtonClick() {
      this.drawer = true
    },
    sliderChange (item, idx) {
      const idxList = [0, 1, 2]
      let lockIdxList = [idx]
      let val = 100 - item.value
      if (this.sliderObj.lockIdx === idx){
        lockIdxList.push(this.sliderObj.lastLockIdx)
        val -= this.wealthList[this.sliderObj.lastLockIdx].value
      } else {
        lockIdxList.push(this.sliderObj.lockIdx)
        val -= this.wealthList[this.sliderObj.lockIdx].value
      }
      const changeIdx = idxList.filter(item => !lockIdxList.includes(item))[0]
      this.wealthList[changeIdx].value = val

      this.wealthList.forEach(item => {
        this.paramsData[item.key] = item.value / 100
      })
      if (this.sliderObj.lockIdx !== idx) {
        this.sliderObj.lastLockIdx = this.sliderObj.lockIdx
        this.sliderObj.lockIdx = idx
      }
      if (this.dynamicCalculate) {
        this.getAllData(false)
      }
      // this.myChartData = [
      //   {
      //     value: [1200, 2000, 40000, 15000, 30000],
      //     name: '收益属性'
      //   },
      //   {
      //     value: [6000, 18000, 18000, 20000, 12000],
      //     name: '现金流属性'
      //   },
      //   {
      //     value: [3000, 15000, 10000, 13000, 10000],
      //     name: '安全属性'
      //   }
      // ]
      // let myChart = this.$echarts.init(document.getElementById('imgChart'))
      // myChart.clear()
      // myChart.setOption({
      //   title: {
      //     text: 'Basic Radar Chart'
      //   },
      //   legend: {
      //     show: false
      //     // data: ['Allocated Budget', 'Actual Spending']
      //   },
      //   radar: {
      //     // shape: 'circle',
      //     indicator: [
      //       { name: '收益属性', max: 6500 },
      //       { name: '波动属性', max: 16000 },
      //       { name: '安全属性', max: 30000 },
      //       { name: '流动属性', max: 38000 },
      //       { name: '现金流属性', max: 52000 }
      //     ]
      //   },
      //   series: [
      //     {
      //       name: 'Budget vs spending',
      //       type: 'radar',
      //       data: this.myChartData
      //     }
      //   ]
      // })
    }
  }
}
</script>

<style>
.selectDiv .el-select .el-input .el-select__caret{
  line-height: 28px;
}
.inputDiv .el-input .el-input__inner{
  border-radius: 23px;
}
.numberYear .el-input .el-input__inner{
  border: transparent;
}
.numberYear .el-input-number .el-input-number__decrease.is-disabled,
.numberYear .el-input-number__increase,
.numberYear .el-input-number__decrease{
  height: 28px;
  line-height: 28px;
  background: #e90a5b;
  color: #fff;
}
.numberYear .el-input-number{
  width: 200px;
}
</style>
<style scoped>
.wealth{
  /*height: 280px;*/
  height: 200px;
  padding: 15px 20px;
}
.pension{
   padding: 15px 20px;
   /* height: calc(100% - 340px); */
   height: 730px;
}
.pension>>>.el-input--suffix .el-input__inner,
.pension>>>.el-input__inner {
   height: 28px;
}
.pension>>>.el-button{
   height: 28px;
   line-height: 0;
   width: 98px;
}
.pension>>>.el-select>>>.el-input__inner{
   border-radius: 5px;
}
.block >>> .el-slider__runway,
.el-slider >>> .el-slider__runway{
   margin: 7px 0;
}
.btns .el-button{
  width: 160px;
  height: 35px;
  line-height: 0;
}
.imgBg{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #efefef;
  margin-top: 20px;
}
.imgBg>>>img{
  width: 40px;
  margin: 13px 10px;
}
/deep/ .el-drawer__body {
  overflow: auto;
}
/deep/ .el-drawer__container ::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ResultNew.vue